import {
  create_shop,
  update_shop,
  delete_shop,
  recover_shop,
  query_shop_list,
} from '@/api/mjstore-model';
import { TableColumn } from '@/typing';
import { SearchConfig, Record } from '@/components/page-model/typing';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';
import {
  slotList,
  btn_list,
  head_btn_list,
  event_obj,
  config,
} from '@/components/page-model/mjstore/mjstore-shop-config';

import { reactive } from 'vue';
import {get_is_active, get_is_active2} from "@/utils/function";

const None = null;
const True = true;
const False = false;

const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org

const search_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'inline',
  },
  fields: [
    {
      type: 'input',
      name: 'code',
      label: '门店编号',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写门店编号',
    },
    {
      type: 'input',
      name: 'name',
      label: '门店名称',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写门店名称',
    },
    {
      type: 'remoteselect',
      name: 'area_id',
      label: '所属片区',
      disabled: false,
      placeholder: '请选择片区',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-area',
    },
    {
      type: 'input',
      name: 'phone',
      label: '门店电话',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写门店电话',
    },
    {
      type: 'input',
      name: 'address',
      label: '门店地址',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写门店地址',
    },
    {
      type: 'remoteselect',
      name: 'person_id',
      label: '负责人',
      disabled: false,
      valueKey: 'id',
      labelKey: 'realname',
      placeholder: '请选择负责人',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'liyu_organization-person',
    },
  ],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    name: null,
    area_id: null,
    person_id: null,
    phone: null,
    address: null,
    person_name: null,
    person_phone: null,
    code: null,
  }),
};
const search_options = {
  is_active: [
    { value: None, name: '全部' },
    {
      value: True,
      name: '可用',
    },
    { value: False, name: '作废' },
  ],
};

const edit_model_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
    labelCol: {
      span: 5,
    },
    wrapperCol: {
      span: 19,
    },
  },
  fields: [
    {
      type: 'input',
      name: 'code',
      label: '门店编号',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写门店编号',
    },
    {
      type: 'input',
      name: 'name',
      label: '门店名称',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写门店名称',
    },
    {
      type: 'input',
      name: 'phone',
      label: '门店电话',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写门店电话',
    },
    {
      type: 'remoteselect',
      name: 'person_id',
      label: '负责人',
      disabled: false,
      valueKey: 'id',
      labelKey: 'realname',
      placeholder: '请选择负责人',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'liyu_organization-person',
    },
    {
      type: 'remoteselect',
      name: 'area_id',
      label: '所属片区',
      disabled: false,
      placeholder: '请选择片区',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-area',
    },
    {
      type: 'datepicker',
      name: 'birthday',
      label: '建账日期',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      showTime: false,
      placeholder: '请填写建账日期',
    },
    {
      type: 'input',
      name: 'address',
      label: '门店地址',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写门店地址',
    },
    {
      type: 'remoteselect',
      name: 'shop_type_id',
      label: '门店类型',
      disabled: false,
      placeholder: '请选择门店类型',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-shoptype',
    },
  ],
  rules: {
    person_phone: [{ pattern: /^1[3456789]\d{9}$/, message: '请填输入正确的手机号' }],
    name: [{ required: true, message: '请填输入门店名称' }],
    phone: [{ required: true, message: '请填输入门店电话' }],
    code: [{ required: true, message: '请填输入门店编码' }],
    shop_type_id: [{ required: true, message: '请选择门店类型' }],
  },
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    name: null,
    phone: null,
    person_id: null,
    code: null,
    area_id: null,
    birthday: null,
  }),
};
const edit_model_config_options = {};

const update_model_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
    labelCol: {
      span: 5,
    },
    wrapperCol: {
      span: 19,
    },
  },
  fields: [
    {
      type: 'input',
      name: 'code',
      label: '门店编码',
      disabled: true,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写门店编码',
    },
    {
      type: 'input',
      name: 'name',
      label: '门店名称',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写门店名称',
    },
    {
      type: 'input',
      name: 'phone',
      label: '门店电话',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写门店电话',
    },
    {
      type: 'remoteselect',
      name: 'person_id',
      label: '负责人',
      disabled: false,
      valueKey: 'id',
      labelKey: 'realname',
      placeholder: '请选择负责人',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'liyu_organization-person',
    },

    {
      type: 'remoteselect',
      name: 'area_id',
      label: '片区',
      disabled: false,
      placeholder: '请选择片区',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-area',
    },
    {
      type: 'datepicker',
      name: 'birthday',
      label: '建账日期',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      showTime: false,
      placeholder: '请填写建账日期',
    },
    {
      type: 'input',
      name: 'address',
      label: '门店地址',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写门店地址',
    },
    {
      type: 'remoteselect',
      name: 'shop_type_id',
      label: '门店类型',
      disabled: false,
      placeholder: '请选择门店类型',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-shoptype',
    },
  ],
  rules: {
    person_phone: [{ pattern: /^1[3456789]\d{9}$/, message: '请填输入正确的手机号' }],
  },
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    name: null,
    phone: null,
    person_id: null,
    code: null,
    area_id: null,
    birthday: null,
  }),
};
const update_model_config_options = {};

const titleList = {
  title: '门店管理',
  addModalTitle: '新建门店',
  updateTitle: '修改门店',
  is_create: true, // 是否有【新建】按钮
  is_update: true, // 是否有【修改】按钮
  is_remove: true, // 是否有【删除】按钮
  is_recover: true, // 是否有【恢复】按钮
};

const api_fields: Record = {
  update: {
    shop_id: 'id',
  },
  delete: {
    shop_id: 'id',
  },
  recover: {
    shop_id: 'id',
  },
  updateData: {
    org_id: 'org_id',
    shop_id: 'id',
  },
};

const baseColumns: TableColumn[] = [
  {
    title: '序号',
    dataIndex: 'index',
    width: 50,
  },
  {
    title: '门店编号',
    dataIndex: 'code',
    checked: true,
  },
  {
    title: '门店名称',
    dataIndex: 'name',
    checked: true,
  },
  {
    title: '门店负责人',
    dataIndex: 'person_name',
    checked: true,
  },
  {
    title: '负责人手机号',
    dataIndex: 'person_phone',
    checked: true,
  },

  {
    title: '门店地址',
    dataIndex: 'address',
    checked: true,
  },
  {
    title: '门店电话',
    dataIndex: 'phone',
    checked: true,
  },
  {
    title: '所属片区',
    dataIndex: 'area__name',
    checked: true,
  },
  {
    title: '门店类型',
    dataIndex: 'shop_type__name',
    checked: true,
  },
  {
    title: '操作',
    width: 200,
    dataIndex: 'is_active',
    checked: true,
    cellComponent: 'action',
    fixed: 'right',
    filterMultiple: false,
    filters: [
      { text: '全部', value: '' },
      { text: '可用', value: true },
      { text: '作废', value: false },
    ],
    content: (record: any, text: any) => {
      return get_is_active2(text);
    },
  },
];
const newSlotList: any = [];
Object.assign(newSlotList, slotList);
newSlotList.push({
  type: 'custom',
  // slotName: 'is_active',
  field_true: '可用',
  field_false: '作废',
});

export default () => {
  return {
    searchConfig: search_config,
    searchConfigOptions: search_options,
    formModalConfig: edit_model_config,
    formModalConfigOptions: edit_model_config_options,
    updateFormModalConfig: update_model_config,
    updateFormModalConfigOptions: update_model_config_options,
    queryData: query_shop_list,
    addData: create_shop,
    updateData: update_shop,
    removeData: delete_shop,
    recoverData: recover_shop,
    baseColumns: baseColumns,
    slotList: newSlotList,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj,
  };
};
